import { createAction, handleActions } from "redux-actions"
import Store from "store"
import {
  apiPost,
  authorizeRequests,
  unauthorizeRequests,
  apiGet,
  apiDelete,
  apiPut,
} from "../utils/apiConnector"
import {
  loginApi,
  getOrganization,
  registerApi,
  storeApi,
  toRecoverApi,
  onRecoverApi,
  taxOfficeApi,
  getInfoApi,
  getNumberApi,
  phoneRecoverApi,
  cashboxApi,
  employeeApi,
  toFiscalApi,
  falseFirstEntry,
  editProfileApi,
} from "../config/apiUrls"
import { alertTypes, showMessage } from "./alerts"
import { refresh as cashboxRefresh } from "./cashbox"

const storeKey = "test-profile"

function saveProfile(profile) {
  Store.set(storeKey, profile)
}

function loadProfile() {
  return Store.get(storeKey)
}

function deleteProfile() {
  Store.remove(storeKey)
}

// Default state
const defaultState = {
  id: null,
  signedIn: false,
  permissions: [],
  currentStore: null,
  stores: [],
  login: null,
  token: null,
  taxOffices: [],
  taxTypes: [],
  services: [],
  numbers: {},
  owner: { Success: false },
  phoneNumber: null,
  organization: {},
  errMsg: "",
  scssMsg: "",
  firstEntry: false,
  isUkm: false,
}

// Action Creators
/// unauthorize()
const unauthorize = createAction("UNAUTHORIZE")
/// authorize(id, login, permissions, stores, token)
const authorize = createAction(
  "AUTHORIZE",
  (
    id,
    login,
    pass,
    permissions,
    stores,
    token,
    company,
    firstEntry,
    isUkm,
  ) => ({
    id,
    login,
    pass,
    permissions,
    stores,
    token,
    company,
    firstEntry,
    isUkm,
  }),
)
/// restoreProfile(profile)
const restoreProfile = createAction("RESTORE_PROFILE")
/// setCurrentStore(id)
const setCurrentStore = createAction("SET_CURRENT_STORE")
const setStores = createAction("SET_STORES")
const getOffices = createAction("GET_OFFICES")
const getTypes = createAction("GET_TYPES")
const getServices = createAction("GET_SERVICES")
const getNumbers = createAction("GET_NUMBERS")
const isOwner = createAction("IS_OWNER")
const saveNumber = createAction("SAVE_NUMBER")
const saveOrganization = createAction("ORGANIZATION_NAME")
const saveErrMsg = createAction("SAVE_ERROR_MESSAGE")
const saveScssMsg = createAction("SAVE_SCSS_MESSAGE")
const editStoreReducer = createAction("EDIT_STORE")
const changeFirstEntry = createAction("FIRST_ENTRY")
const changeFirstEntryValue = createAction("CHANGE_FIRST_ENTRY_VALUE")

// Reducer
const reducer = handleActions(
  {
    [unauthorize]: (state, action) => ({ ...defaultState }),
    [authorize]: (state, { payload }) => ({
      ...payload,
      currentStore: payload.stores[0],
      signedIn: true,
    }),
    [restoreProfile]: (state, { payload }) => ({ ...state, ...payload }),
    [setCurrentStore]: (state, { payload }) => ({
      ...state,
      currentStore: state.stores.filter((s) => s.id === payload)[0],
    }),
    [getOffices]: (state, { payload }) => ({
      ...state,
      taxOffices: [...payload],
    }),
    [getTypes]: (state, { payload }) => ({
      ...state,
      taxTypes: [...payload],
    }),
    [getServices]: (state, { payload }) => ({
      ...state,
      services: [...payload],
    }),
    [getNumbers]: (state, { payload }) => ({
      ...state,
      numbers: { ...payload },
    }),
    [isOwner]: (state, { payload }) => ({
      ...state,
      owner: { ...payload },
    }),
    [setStores]: (state, { payload }) => ({
      ...state,
      stores: [...payload],
    }),
    [editStoreReducer]: (state, { payload }) => ({
      ...state,
    }),
    [saveNumber]: (state, { payload }) => ({
      ...state,
      phoneNumber: payload,
    }),
    [saveOrganization]: (state, { payload }) => ({
      ...state,
      organization: { ...payload },
    }),
    [saveErrMsg]: (state, { payload }) => ({
      ...state,
      errMsg: payload,
    }),
    [saveScssMsg]: (state, { payload }) => ({
      ...state,
      scssMsg: payload,
    }),
    [changeFirstEntry]: (state, { payload }) => ({
      ...state,
      firstEntry: false,
    }),
    [changeFirstEntryValue]: (state, { payload }) => ({
      ...state,
      firstEntry: payload,
    }),
  },
  defaultState,
)
export default reducer

export function changeFirstEntryFunction(value) {
  return (dispatch) => {
    return apiPut(editProfileApi, { firstEntry: false })
      .onOk((res) => {
        dispatch(changeFirstEntryValue(value))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        // dispatch(actions.setLoading(false))
      })
      .startSingle()
  }
}

// Thunk
export function getStores() {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    return apiGet(storeApi)
      .onOk((res) => {
        dispatch(setStores(res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        // dispatch(actions.setLoading(false))
      })
      .startSingle()
  }
}

export function exportSaveErrMsg(text) {
  return (dispatch) => dispatch(saveErrMsg(text))
}

export function exportSaveScssMsg(text) {
  return (dispatch) => {
    if (!text) {
      dispatch(isOwner(false))
    }
    dispatch(saveScssMsg(text))
  }
}

export function restoreSession() {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    const profile = loadProfile()
    if (profile) {
      authorizeRequests(profile.token)
      dispatch(restoreProfile(profile))
    }
  }
}

export function signIn(login, pass, callback) {
  return (dispatch, getState) => {
    return (
      apiPost(loginApi, { login, pass })
        .onOk((res) => {
          const {
            id,
            token,
            roles,
            stores,
            company,
            firstEntry,
            isUkm,
          } = res.data.response
          authorizeRequests(token)
          dispatch(
            authorize(
              id,
              login,
              pass,
              roles,
              stores,
              token,
              company,
              firstEntry,
              isUkm,
            ),
          )
          saveProfile(getState().profile)
        })
        .onFail((res) => {
          dispatch(showMessage(res.data.response, alertTypes.error))
          callback()
        })
        // .onThrow((thrown) => {
        //   dispatch(showMessage(thrown.message, alertTypes.error))
        //   callback()
        // })
        .startSingle()
    )
  }
}

export function signOut() {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    unauthorizeRequests()
    deleteProfile()
    dispatch(unauthorize())
  }
}

export function selectStore(id) {
  return (dispatch, getState) => {
    dispatch(setCurrentStore(id))
    saveProfile(getState().profile)
  }
}

export function register(data, redirect) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiPost(registerApi, data)
      .onOk(() => {
        dispatch(showMessage("Регистрация прошла успешно!", alertTypes.success))

        redirect.history.push("/")
      })
      .onFail((res) => {
        dispatch(showMessage(res.data.response, alertTypes.error))
      })
      // .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function toRecover(data) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiGet(toRecoverApi + "/" + data.bin + "/" + data.login)
      .onOk((res) => {
        dispatch(showMessage(res.data.response, alertTypes.success))
      })
      .onFail((res) => {
        dispatch(showMessage(res.data.response, alertTypes.error))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function onRecover(data, redirect) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiPost(onRecoverApi, data)
      .onOk((res) => {
        dispatch(showMessage(res.data.response, alertTypes.success))
        redirect.history.push("/")
      })
      .onFail((res) => {
        dispatch(showMessage(res.data.response, alertTypes.error))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function getUserInfo(xin) {
  return (dispatch, getState) => {
    apiGet(getInfoApi + "/" + xin)
      .onOk((res) => {
        dispatch(isOwner(res.data.response))
        if (getState().profile.errMsg.length > 2) {
          dispatch(saveErrMsg(""))
        } else {
          dispatch(saveScssMsg("Проверка пройдена"))
        }
      })
      .onFail((res) => {
        dispatch(showMessage(res.data.response, alertTypes.error))
        dispatch(saveScssMsg(""))
        dispatch(saveErrMsg(res.data.response))
      })
      // .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function getTaxOffices() {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiGet(taxOfficeApi)
      .onOk((res) => {
        dispatch(getOffices(res.data.response.taxRegions))
        dispatch(getTypes(res.data.response.taxTypes))
        dispatch(getServices(res.data.response.services))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function takeNumbers(numbers) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(getNumbers(numbers))
  }
}

export function createStore(data) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiPost(storeApi, data)
      .onOk((res) => {
        localStorage.setItem("createdStoreId", res.data.response)
        dispatch(showMessage("Магазин успешно создан!", alertTypes.success))
        dispatch(getStores())
      })
      .afterAll(() => {
        // dispatch(setLoading(false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}
export function deleteStore(storeId) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiDelete(storeApi, { storeId })
      .onOk(() => {
        dispatch(showMessage("Магазин успешно удален!", alertTypes.success))
        dispatch(getStores())
      })
      .afterAll(() => {
        // dispatch(setLoading(false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}

export function editStore(editedData) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    // dispatch(setEmployeeLoading(editedData.employeeId, true))
    apiPut(storeApi, editedData)
      .onOk((res) => {
        dispatch(
          showMessage("Магазин успешно отредактирован!", alertTypes.success),
        )
        dispatch(getStores())
        dispatch(editStoreReducer())
      })
      .afterAll(() => {
        // dispatch(setEmployeeLoading(editedData.employeeId, false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}

export function getNumber(data) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiGet(getNumberApi + "/" + data.login + "/" + data.login)
      .onOk((res) => {
        dispatch(saveNumber(res.data.response.phone))
      })
      .onFail((res) => {
        dispatch(showMessage(res.data.response, alertTypes.error))
      })
      .startSingle()
  }
}

export function phoneRecover(data, redirect) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiPost(phoneRecoverApi, data)
      .onOk((res) => {
        dispatch(showMessage(res.data.response, alertTypes.success))
        redirect.history.push("/")
      })
      .onFail((res) => {
        dispatch(showMessage(res.data.response, alertTypes.error))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function getOrganizationData() {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiGet(getOrganization)
      .onOk((res) => {
        dispatch(saveOrganization(res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

// export function closeFirstEntry(data) {
//   return (dispatch, getState) => {
//     const data = {
//       firstEntry: false,
//     }
//     apiPut(falseFirstEntry, data)
//       .onOk((res) => {
//         dispatch(changeFirstEntry())
//         saveProfile(getState().profile)
//       })
//       .useDefaultErrorHandlers(dispatch)
//       .startSingle()
//   }
// }

export function closeFirstEntry(data) {
  return (dispatch, getState) => {
    const storeData = {
      name: data.storeName,
      address: data.storeAddress,
    }
    apiPost(storeApi, storeData)
      .onOk((res) => {
        localStorage.setItem("createdStoreId", res.data.response)
        dispatch(getStores())
        dispatch(showMessage("Магазин успешно создан!", alertTypes.success))
        setTimeout(() => {
          const cashboxData = {
            name: data.cashboxName,
            store: getState().profile.stores[0].id,
          }
          apiPost(cashboxApi, cashboxData)
            .onOk(() => {
              dispatch(
                showMessage("Касса успешно добавлена!", alertTypes.success),
              )
              dispatch(cashboxRefresh())
              // dispatch(setCashbox({}))
              setTimeout(() => {
                if (data.wannaFiscal) {
                  const fiscalData = {
                    id: getState().cashbox.data[0].id,
                    wklogin: data.wkLogin,
                    wkpass: data.wkPass,
                    serialNumber: data.serialNumber,
                    npfu: data.npfu,
                  }
                  apiPut(toFiscalApi, fiscalData)
                    .onOk((res) => {
                      dispatch(
                        showMessage(
                          "Касса успешно фискализирована!",
                          alertTypes.success,
                        ),
                      )
                      apiPut(falseFirstEntry, { firstEntry: false })
                        .onOk((res) => {
                          dispatch(changeFirstEntry())
                          saveProfile(getState().profile)
                        })
                        .useDefaultErrorHandlers(dispatch)
                        .startSingle()
                      // dispatch(refresh())
                    })
                    .useDefaultErrorHandlers(dispatch)
                    .startSingle()
                }
              }, 1000)
              setTimeout(() => {
                if (data.wannaEmployee) {
                  const employeeData = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    login: data.employeeLogin,
                    middleName: data.middleName,
                    pass: data.pass,
                    phone: data.phone,
                    roles: data.roles,
                    stores: [getState().profile.stores[0].id],
                  }
                  apiPost(employeeApi, employeeData)
                    .onOk(() => {
                      // dispatch(refresh())
                      apiPut(falseFirstEntry, { firstEntry: false })
                        .onOk((res) => {
                          dispatch(changeFirstEntry())
                          saveProfile(getState().profile)
                          dispatch(
                            showMessage(
                              "Сотрудник успешно добавлен!",
                              alertTypes.success,
                            ),
                          )
                        })
                        .useDefaultErrorHandlers(dispatch)
                        .startSingle()
                    })
                    .useDefaultErrorHandlers(dispatch)
                    .start()
                }
              }, 1000)
            })
            .useDefaultErrorHandlers(dispatch)
            .start()
          if (!data.wannaFiscal && !data.wannaEmployee) {
            apiPut(falseFirstEntry, { firstEntry: false })
              .onOk((res) => {
                dispatch(changeFirstEntry())
                saveProfile(getState().profile)
              })
              .useDefaultErrorHandlers(dispatch)
              .startSingle()
          }
        }, 1000)
      })
      .afterAll(() => {
        // dispatch(setLoading(false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}
